"use client";

import { c as _c } from "react/compiler-runtime";
import { FEATURE_FLAG_KEYS } from "@agroproj/backend/convex/constants/featureFlags";
import { useRouter, useSearchParams } from "next/navigation";
import { useCallback } from "react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useConvexFeatureFlag } from "@/hooks/use-convex-feature-flag";
import { ProjectFilters } from "./components/project-filters";
import { ProjectsTable } from "./components/projects-table";
import { useProjectsData } from "./hooks/use-projects-data";
type TechnicalProjectTypeFilter = "operating_cost" | "investment";
type ProjectsPageContentProps = {
  searchParams: {
    search: string;
    status: string[];
    workflowStatus: string[];
    activity: string[];
    harvest: string[];
    classification: string[];
    program: string[];
    updatedFrom: string;
    updatedTo: string;
    technicalProjectType: TechnicalProjectTypeFilter;
  };
};
export function ProjectsPageContent(t0) {
  const $ = _c(34);
  const {
    searchParams
  } = t0;
  const router = useRouter();
  const urlSearchParams = useSearchParams();
  const {
    enabled: investmentCreateFlowEnabled
  } = useConvexFeatureFlag(FEATURE_FLAG_KEYS.INVESTMENT_CREATE_FLOW);
  const activeTechnicalProjectType = investmentCreateFlowEnabled ? searchParams.technicalProjectType : undefined;
  const visibleTechnicalProjectType = activeTechnicalProjectType ?? "operating_cost";
  let t1;
  if ($[0] !== activeTechnicalProjectType || $[1] !== searchParams.activity || $[2] !== searchParams.classification || $[3] !== searchParams.harvest || $[4] !== searchParams.program || $[5] !== searchParams.search || $[6] !== searchParams.status || $[7] !== searchParams.updatedFrom || $[8] !== searchParams.updatedTo || $[9] !== searchParams.workflowStatus) {
    t1 = {
      search: searchParams.search,
      status: searchParams.status,
      workflowStatus: searchParams.workflowStatus,
      activity: searchParams.activity,
      harvest: searchParams.harvest,
      classification: searchParams.classification,
      program: searchParams.program,
      updatedFrom: searchParams.updatedFrom,
      updatedTo: searchParams.updatedTo,
      technicalProjectType: activeTechnicalProjectType
    };
    $[0] = activeTechnicalProjectType;
    $[1] = searchParams.activity;
    $[2] = searchParams.classification;
    $[3] = searchParams.harvest;
    $[4] = searchParams.program;
    $[5] = searchParams.search;
    $[6] = searchParams.status;
    $[7] = searchParams.updatedFrom;
    $[8] = searchParams.updatedTo;
    $[9] = searchParams.workflowStatus;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  const {
    projects,
    uniqueHarvests,
    producerClassifications,
    isLoadingProjects,
    isSearching,
    isStale
  } = useProjectsData(t1);
  let t2;
  if ($[11] !== router || $[12] !== urlSearchParams) {
    t2 = value => {
      if (value !== "operating_cost" && value !== "investment") {
        return;
      }
      const nextType = value;
      const next = new URLSearchParams(urlSearchParams.toString());
      next.set("technicalProjectType", nextType);
      if (nextType === "investment") {
        next.delete("activity");
        next.delete("harvest");
      } else {
        next.delete("program");
        next.delete("updatedFrom");
        next.delete("updatedTo");
      }
      router.push(`?${next.toString()}`);
    };
    $[11] = router;
    $[12] = urlSearchParams;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  const handleTechnicalProjectTypeChange = t2;
  let t3;
  if ($[14] !== handleTechnicalProjectTypeChange || $[15] !== investmentCreateFlowEnabled || $[16] !== searchParams.technicalProjectType) {
    t3 = investmentCreateFlowEnabled ? <Tabs value={searchParams.technicalProjectType} onValueChange={handleTechnicalProjectTypeChange}><TabsList><TabsTrigger value="operating_cost">Custeio</TabsTrigger><TabsTrigger value="investment">Investimento</TabsTrigger></TabsList></Tabs> : null;
    $[14] = handleTechnicalProjectTypeChange;
    $[15] = investmentCreateFlowEnabled;
    $[16] = searchParams.technicalProjectType;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== producerClassifications || $[19] !== uniqueHarvests || $[20] !== visibleTechnicalProjectType) {
    t4 = <ProjectFilters producerClassifications={producerClassifications} technicalProjectType={visibleTechnicalProjectType} uniqueHarvests={uniqueHarvests} />;
    $[18] = producerClassifications;
    $[19] = uniqueHarvests;
    $[20] = visibleTechnicalProjectType;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== isSearching) {
    t5 = isSearching ? <output className="text-muted-foreground">Pesquisando...</output> : null;
    $[22] = isSearching;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  let t6;
  if ($[24] !== isLoadingProjects || $[25] !== isStale || $[26] !== projects || $[27] !== visibleTechnicalProjectType) {
    t6 = <ProjectsTable data={projects} isLoading={isLoadingProjects} isStale={isStale} mode={visibleTechnicalProjectType} />;
    $[24] = isLoadingProjects;
    $[25] = isStale;
    $[26] = projects;
    $[27] = visibleTechnicalProjectType;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  let t7;
  if ($[29] !== t3 || $[30] !== t4 || $[31] !== t5 || $[32] !== t6) {
    t7 = <div className="flex flex-col gap-4">{t3}{t4}{t5}{t6}</div>;
    $[29] = t3;
    $[30] = t4;
    $[31] = t5;
    $[32] = t6;
    $[33] = t7;
  } else {
    t7 = $[33];
  }
  return t7;
}